import { initializeApp } from "firebase/app";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBjxLzsYDeLfSFcFvJSO88AoehZPNzEkIc",
  authDomain: "studio-pass-pro.firebaseapp.com",
  projectId: "studio-pass-pro",
  storageBucket: "studio-pass-pro.firebasestorage.app",
  messagingSenderId: "748205473982",
  appId: "1:748205473982:web:219d831e13984a107bdeef",
  measurementId: "G-8K62W2J295",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth, RecaptchaVerifier, signInWithPhoneNumber };
